<template>
  <div class="account-settings-info-view">
    <a-row :gutter="16">
      <a-col :md="24" :lg="16">
        <a-form layout="vertical" :form="form">
          <a-form-item label="账号">
            <a-input
              placeholder="这是登录名呀"
              v-decorator="[ 'userid', {rules: [{required: true, message: '请输入登录名！'}]}]"
              :disabled="isEdit"
            />
          </a-form-item>
          <a-form-item label="昵称">
            <a-input
              placeholder="这是你的昵称呀"
              v-decorator="[ 'username', {rules: [{required: true, message: '请输入昵称！'}]}]"
            />
          </a-form-item>
          <a-form-item label="供应商编码" v-if="isvendor">
            <a-input
              placeholder="供应商编码"
              v-decorator="[ 'cvencode' ]"
              :disabled="isEdit"
            />
          </a-form-item>
          <a-form-item label="供应商" v-if="isvendor">
            <a-input
              placeholder="供应商"
              v-decorator="[ 'cvenname' ]"
              :disabled="isEdit"
            />
          </a-form-item>
          <a-form-item label="部门信息" v-if="!isvendor">
            <a-input
              placeholder="部门"
              v-decorator="[ 'dept_name' ]"
              :disabled="isEdit"
            />
          </a-form-item>
          <a-form-item label="手机号码">
            <a-input 
              placeholder="请输入手机号码！"
              v-decorator="[ 'phone', {rules: [{pattern: /^1(3|4|5|7|8)\d{9}$/, message: '请输入手机号码!'}]}]"
            />
          </a-form-item>
          <a-form-item label="电子邮件">
            <a-input
              placeholder="请输入电子邮件！"
              v-decorator="[ 'email', {rules: [{pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: '请输入邮箱地址!'}]}]"
            />
          </a-form-item>
          <a-form-item label="创建时间" :required="false">
            <a-input
              placeholder="创建时间"
              v-decorator="[ 'createtime']"
              :disabled="isEdit"
            />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" htmlType="submit" @click="submitInfo">
              提交
            </a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { getOwnerInfo } from '@/api/login'
import { updateOwnerInfo } from '@/api/manage'
export default {
  name: 'Baseinfo',
  data() {
    return {
      visible: false,
      isEdit: true,
      isvendor:true,
      form: this.$form.createForm(this),
      userInfo: {},
    }
  },
  created() {
    const that = this
    that.userInfo = that.$store.getters.userinfo
    that.isvendor = that.userInfo.isvendor
    that.$nextTick(() => {
      that.form.setFieldsValue({ userid: that.userInfo.userid, username: that.userInfo.username, createtime: that.userInfo.createtime,
            phone: that.userInfo.phone, email: that.userInfo.email, dept_name: that.userInfo.dept_name, cvenname: that.userInfo.cvenname,cvencode: that.userInfo.cvencode})
    })
  },
  methods: {
    submitInfo() {
      const that = this
      that.form.validateFields(
        (err,values) => {
          if (!err) {
            const subParam = values
            updateOwnerInfo(subParam)
            .then(result => {
              if(result.code === '0' || result.code === 1){
                that.$message.success('操作成功！')
                getOwnerInfo().then(ownerInof => {
                  if(ownerInof.code ==='0' || ownerInof.code === 0){
                    that.$store.commit('SET_USERINFO',ownerInof.data)
                  }
                })
              } else {
                that.$message.error('操作失败！')
              }
            })
          }else{
            that.$message.error('请完善信息')
          }
        },
      )
    }
  }
}
</script>


